import React from 'react';
import { Box, IconButton, ListItemText, ListItemButton, List, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const FolderItem = ({
  folder,
  onTemplateSelect,
  onTemplateHover,
  onTemplateEdit,
  onTemplateDelete,
  canEdit,
  canDelete,
}) => {
  const showActions = canEdit || canDelete;

  return (
    <Box>
      <ListItemText primary={folder.name} sx={{ pl: 2, py: 1 }} />
      <List component='div' disablePadding>
        {folder.templates.map(template => (
          <ListItemButton
            key={template._id}
            sx={{ pl: 4 }}
            onMouseEnter={() => onTemplateHover(template)}
            onMouseLeave={() => onTemplateHover(null)}
            onClick={() => onTemplateSelect(template)}
          >
            <ListItemText primary={template.name} />
            {showActions && (
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                {canEdit && (
                  <Tooltip title='Textvorlage bearbeiten'>
                    <IconButton
                      size='small'
                      onClick={event => {
                        event.stopPropagation();
                        onTemplateEdit(template);
                      }}
                    >
                      <EditIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
                {canDelete && (
                  <Tooltip title='Textvorlage löschen'>
                    <IconButton
                      size='small'
                      color='error'
                      onClick={event => {
                        event.stopPropagation();
                        onTemplateDelete(template);
                      }}
                    >
                      <DeleteIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default FolderItem;
